import React from 'react';
import GenericDialog from '@common/GenericDialog';
import { VisualisationWidget } from '../../visualisationWidgets/VisualisationWidget';
import DescriptionIcon from '@mui/icons-material/Description';
import FunctionsIcon from '@mui/icons-material/Functions';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import GeoGebraEmbed from './GeoGebraEmbed';
import GeogebraTaxonomy from './GeogebraTaxonomy';
import questionsTheme from './questionsTheme';

export const VisualisationModal = ({ isOpen, isGenerating, remediationError, remediationWidget, onClose }) => (
    <GenericDialog
        open={isOpen}
        onClose={onClose}
        title="Interactive Visualisation"
        dialogWidth={1000}
        isLoading={isGenerating}
        errorMessage={remediationError}
        allowFullScreen={true}
        buttons={[{ name: 'Close', callback: onClose }]}
    >
        {remediationWidget && (
            <VisualisationWidget data={remediationWidget} hideExplanation={true} />
        )}
    </GenericDialog>
);

export const GeoGebraModal = ({ isOpen, appletId, title = 'Interactive GeoGebra', onClose, height = 600, showToolbar = true, showAlgebraInput = true }) => (
    <GenericDialog
        open={isOpen}
        onClose={onClose}
        title={title}
        icon={<FunctionsIcon className="margin-r--s" style={{ color: questionsTheme.primaryTeal }} />}
        dialogWidth={1000}
        allowFullScreen={true}
        buttons={[{ name: 'Close', callback: onClose }]}
    >
        {appletId && (
            <GeoGebraEmbed
                appletId={appletId}
                height={height}
                showToolbar={showToolbar}
                showAlgebraInput={showAlgebraInput}
                showOpenButton={false}
            />
        )}
    </GenericDialog>
);

export const NotesModal = ({
    isOpen,
    questionList,
    notesQuestionId,
    notes,
    currentNoteText,
    setCurrentNoteText,
    onClose,
    onSave,
    onDelete,
}) => {
    const foundIndex = questionList.findIndex(q => q.questionId === notesQuestionId);
    const questionNumber = foundIndex >= 0 ? foundIndex + 1 : null;
    const dialogTitle = questionNumber ? `Notes for Question ${questionNumber}` : 'Notes';

    return (
        <GenericDialog
            open={isOpen}
            onClose={onClose}
            title={dialogTitle}
            icon={<DescriptionIcon className="margin-r--s" style={{ color: questionsTheme.primaryTeal }} />}
            buttons={[
                {
                    name: 'Cancel',
                    callback: onClose,
                    extraProps: { className: 'ch-btn-outline' }
                },
                ...(notes[notesQuestionId]
                    ? [{
                        name: 'Delete',
                        callback: onDelete,
                        extraProps: {
                            style: {
                                backgroundColor: questionsTheme.incorrectRed,
                                borderColor: questionsTheme.incorrectRed,
                                color: '#fff'
                            }
                        }
                    }]
                    : []
                ),
                { name: 'Save', callback: onSave }
            ]}
        >
            <textarea
                className="ch-textarea"
                value={currentNoteText}
                onChange={(e) => setCurrentNoteText(e.target.value)}
                placeholder="Write your notes here..."
                style={{ minHeight: '150px' }}
            />
        </GenericDialog>
    );
};

export const GeogebraTaxonomyModal = ({ isOpen, currentQuestion, conceptId, onClose }) => (
    <GenericDialog
        open={isOpen}
        onClose={onClose}
        title="GeoGebra Topic Browser"
        icon={<LibraryBooksIcon className="margin-r--s" style={{ color: questionsTheme.primaryTeal }} />}
        dialogWidth={1200}
        allowFullScreen={true}
        buttons={[{ name: 'Close', callback: onClose }]}
    >
        <div style={{ minHeight: '600px', maxHeight: '80vh', overflow: 'auto' }}>
            <GeogebraTaxonomy
                currentQuestion={currentQuestion}
                conceptId={conceptId}
            />
        </div>
    </GenericDialog>
);
